import JSEncrypt from 'jsencrypt'
import { stringify } from 'qs'
import request from '@/utils/request'
import { selectApi } from '@/config/config'
import { getUserInfo } from '@/utils/common'
import { pubKey } from '@/config/config'

export const login = (data) => {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(pubKey);
  const encrypted = encrypt.encrypt(stringify(data));
  return request(`/api/xtgl_zhxx/login.do?${stringify({ p: encrypted })}`, {
    uncheck: true
  })
}

// 扫码登录
export const qrLogin = (code) => {
  return request('/api/xtgl_zhxx/qrCodeLogin.do?code=' + code)
}

export const getCurrentUser = () => {
  const userInfo  = getUserInfo()
  return request('/api/xtgl_zhxx/currentUser.do?userid=' + userInfo.userid, {
    uncheck: true
  })
}

// 获取菜单数据
export const getMenuData = () => {
  const userInfo  = getUserInfo()
  return request('/api/xtgl_hmxx/menuData.do?userid=' + userInfo.userid, {
    uncheck: true
  })
}

// 获取权限数据
export const getTopPermissions = () => {
  const userInfo  = getUserInfo()
  if(!userInfo || !userInfo.userid) {
    return {
      success: false,
      data: []
    }
  }
  return request(selectApi, {
    params: {
      sqlfilename: 'sql-zcoa.xml',
      sqlkey: 'anxx-qxcdanlist',
      userid: userInfo.userid,
      hmid: '2c90645181ba10b20181c20260223001'
    }
  })
}

export const savePassword = (data) => {
  return request('/api/xtgl_ygxx/setMm.do', {
    params: data
  })
}

export const checkPassord = (data) => {
  return request('')
}

export const getDxyz = (data) => {
  return request('')
}

// 获取员工角色列表
export const list = (data) => {
  const userInfo  = getUserInfo()
  return request('/jxs/JxsCgdd/list', {
    method: 'post',
    data: {
      ...data,
      jxsid:userInfo.jxsid
    }
  })
}
